import { render, staticRenderFns } from "./policiesRegulations.vue?vue&type=template&id=361f5efa"
import script from "./policiesRegulations.vue?vue&type=script&lang=js"
export * from "./policiesRegulations.vue?vue&type=script&lang=js"
import style0 from "./policiesRegulations.vue?vue&type=style&index=0&id=361f5efa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports